import { render, staticRenderFns } from "./StickerBanner.vue?vue&type=template&id=6d54b398&scoped=true&"
import script from "./StickerBanner.vue?vue&type=script&lang=js&"
export * from "./StickerBanner.vue?vue&type=script&lang=js&"
import style0 from "./StickerBanner.vue?vue&type=style&index=0&id=6d54b398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d54b398",
  null
  
)

export default component.exports